import {
  GET_CUSTOMER_LIST_EXPORT,
  GET_CUSTOMER_LIST_EXPORT_FAILURE,
  GET_CUSTOMER_LIST_EXPORT_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getCustomerExportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_LIST_EXPORT:
      return { ...state, loading: true };
    case GET_CUSTOMER_LIST_EXPORT_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_CUSTOMER_LIST_EXPORT_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getCustomerExportReducer;
